import styled from "styled-components";

export const Main = styled.main`
  display: flex;
  flex-direction: row;
  user-select: none;
`;
